export default {
    SUBMIT_SUCCESS_NANNY_FORM: {
        TITLE: 'Thank you for your application to join our team!',
        MESSAGE: 'We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the candidates we select. Thanks for your understanding! You can now safely close this window.'
    },
    SUBMIT_SUCCESS_REFERENCE_FORM: {
        TITLE: 'Thank you for your information!',
        MESSAGE: 'The reference information you submitted is very important for us. You can safely close this window now.'
    },
    SUBMIT_SUCCESS_FAMILY_FORM: {
        INNER_HTML: `
        <h2>Thank you for submitting your registration!</h2>
        <h5>We will be in touch with you shortly! You can now safely close this window.</h5>
        `
    },
    PROFILE_COMPLETE_RESULT_DIALOG: {
        MESSAGE: 'Thanks for letting us know, we will be in touch with you shortly!'
    },
    VIDEO_UPLOADE_RESULT_DIALOG: {
        INNER_HTML: `
        <h2>Video is uploaded successfully!</h2>
        <h5>Thank you for submitting the introduction video. If it is not displayed in screen, please wait for a while then manually click Refresh (<i class="material-icons" style='position: absolute;'>refresh</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;) button</h5>
        `
    },
    UPDATE_SECTION_SUCCESS: {
        TITLE: 'Section Saved',
        MESSAGE: 'Saved {0} section!'
    },
    UPDATE_FAMILY_FORM_SUCCESS: {
        TITLE: 'Family Form Updated',
        MESSAGE: 'Updated Family Form successfully'
    },
    UPDATE_SECTION_REJECT: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    SUBMIT_REJECT_FORM: {
        TITLE: 'Thank you',
        MESSAGE: "We will review the information you have submitted and be in touch with you if we'd like to move forward."
    },
    STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Status updated.'
    },
    STATUS_UPDATED_RESULT_DIALOG_WITH_NO_EMAIL_TEMPLATE: {
        INNER_HTML: `<h2>Status Updated</h2>
        <h5>Would you like to trigger an email on a change to this status? <button class="btn btn-secondary" id="add-template-button">Add email</button></h5>`
    },
    STATUS_UPDATED_REFUND_RESULT_DIALOG: {
        TITLE: 'Status updated. Refund to client 1 credit'
    },
    SUCCESSFULLY_BROADCAST_RESULT_DIALOG: {
        TITLE: 'Broadcast sent!'
    },
    NANNY_ASSIGNED_RESULT_DIALOG: {
        TITLE: 'Candidate assigned!',
        MESSAGE: 'Please proceed to the {0} notification.'
    },
    NANNY_ASSIGNED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: 'Candidate assigned!',
    },
    NANNY_ASSIGNED_CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: 'Candidate assigned and Client charged!',
        MESSAGE: 'Please proceed to the {0} notification.'
    },
    NANNY_ASSIGNED_CLIENT_CHARGED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: 'Candidate assigned and Client charged!',
    },
    NANNY_BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Candidate assigned to the selected jobs",
        MESSAGE: "Please proceed to the {0} notification."
    },
    NANNY_BULK_ASSIGNED_WITHOUT_NOTIFICATION_RESULT_DIALOG: {
        TITLE: "Candidate assigned to the selected jobs",
    },
    BULK_ASSIGNED_RESULT_DIALOG: {
        TITLE: "Candidates assigned",
    },
    JOB_UPDATED_RESULT_DIALOG: {
        TITLE: 'Job updated!'
    },
    JOB_POSTED_RESULT_DIALOG: {
        TITLE: 'Job created!'
    },
    JOB_ACCEPTANCE_TYPE_RESULT_DIALOG: {
        TITLE: 'Acceptance Type updated'
    },
    JOB_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client charged and job status updated!'
    },
    CLIENT_CHARGED_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Stripe!'
    },
    CLIENT_CHARGED_STRIPE_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Stripe!'
    },
    CLIENT_CHARGED_AUTHORIZE_NET_RESULT_DIALOG: {
        TITLE: 'Client has been charged through Authorize.Net!'
    },
    BULK_JOBS_CHARGED_RESULT_DIALOG: {
        TITLE: 'Clients charged and jobs status updated!'
    },
    BULK_JOBS_CHARGED_WARNING_RESULT_DIALOG: {
        INNER_HTML: `<h2>Clients charged and jobs status updated!</h2>
        <div>Failed to charge the following bookings</div>
        <ul>{0}</ul>`,
    },
    BULK_INVOICE_RESULT_DIALOG: {
        TITLE: "Clients Invoiced!"
    },
    BULK_TRANSFER_RESULT_DIALOG: {
        TITLE: "Clients charged and candidate paid and jobs status updated!"
    },
    BULK_TRANSFER_WARNING_RESULT_DIALOG: {
        INNER_HTML: `<h2>Clients charged and candidate paid and jobs status updated!</h2>
       {0}`,
    },
    MESSAGE_SENT_RESULT_DIALOG: {
        TITLE: 'Message sent.'
    },
    MESSAGE_SCHEDULED_SEND_RESULT_DIALOG: {
        TITLE: 'Message is scheduled to send'
    },
    CHANGE_PASSWORD_RESULT_DIALOG: {
        TITLE: 'Password has been reset successfully.'
    },
    SAVE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been saved successfully.'
    },
    DELETE_PROFILE_PICTURE_RESULT_DIALOG: {
        TITLE: 'Profile picture has been deleted successfully.'
    },
    DOCUMENT_UPLOADED_RESULT_DIALOG: {
        TITLE: 'Documents uploaded.',
        MESSAGE: "It could take a few seconds for them to process, if they don't update right away try refreshing in a minute!"
    },
    DOCUMENT_SIGNED_RESULT_DIALOG: {
        TITLE: 'Your document has been signed.'
    },
    DOCUMENT_SAVED_RESULT_DIALOG: {
        TITLE: 'Your document has been saved.'
    },
    DOCUMENT_INFORMATION_UPDATED_RESULT_DIALOG: {
        TITLE: 'The additional information of the document {0} is updated'
    },
    TEMPLATE_CREATED_RESULT_DIALOG: {
        TITLE: 'Template created.'
    },
    TEMPLATE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Template updated'
    },
    TEMPLATE_DELETED_RESULT_DIALOG: {
        TITLE: 'Template deleted'
    },
    TEMPLATE_DUPLICATED_RESULT_DIALOG: {
        TITLE: 'Template duplicated.'
    },
    PASSWORD_RESET_RESULT_DIALOG: {
        TITLE: 'Password reset',
        MESSAGE: 'Password reset to {0}'
    },
    PROFILE_BUILDER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Profile builder updated'
    },
    EMAIL_FOOTER_SAVED_RESULT_DIALOG: {
        TITLE: 'Email footer is saved'
    },
    NOTIFICATION_SETTING_SAVED_RESULT_DIALOG: {
        TITLE: 'Notification settings saved'
    },
    ADDITIONAL_ADMIN_SETTINGS_SAVED_RESULT_DIALOG: {
        TITLE: 'Additional admin settings saved'
    },
    MANAGER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Manager updated.'
    },
    ADMIN_ADDED_RESULT_DIALOG: {
        TITLE: 'Administrator added'
    },
    ADMIN_UPDATED_RESULT_DIALOG: {
        TITLE: 'Administrator updated'
    },
    ADMIN_DELETED_RESULT_DIALOG: {
        TITLE: 'Administrator deleted'
    },
    LOCATIONS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Locations updated'
    },
    BULK_DATA_UPDATED_RESULT_DIALOG: {
        TITLE: '{0} updated'
    },
    BULK_DATA_ADDED_RESULT_DIALOG: {
        TITLE: '{0} Added'
    },
    LANGUAGE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Language updated'
    },
    JOB_BROADCAST_SENT_RESULT_DIALOG: {
        TITLE: 'Broadcast sent to {0} candidates!'
    },
    JOB_VIEWS_RESULT_DIALOG: {
        TITLE: 'Job views',
        MESSAGE: 'Number of times viewed: {0}'
    },
    BLAST_OFF_RESULT_DIALOG: {
        TITLE: 'Blast Off!',
        MESSAGE: "Your emails are on their way! It may take a few minutes, depending on how many are being sent. They will appear in the general email log and the individual user's email logs as they are sent."
    },
    NOTE_SAVED_RESULT_DIALOG: {
        TITLE: 'Note saved!'
    },
    SAVE_AND_ADD_NEW_OBJECT: {
        TITLE: '{0} saved, please add another one!',
        CLOSE_LABEL: 'OK'
    },
    APPLICATION_STATUS_UPDATED_RESULT_DIALOG: {
        TITLE: 'Thanks for letting us know!'
    },
    JOB_ACCEPTED_RESULT_DIALOG: {
        TITLE: "Congrats, you've accepted this job!",
        MESSAGE: 'All the details will appear in your dashboard under "My Jobs".'
    },
    UPDATE_VISIBILITY_SCOPE_RESULT_DIALOG: {
        TITLE: 'Visibility scope of the {0} is updated to {1}'
    },
    CHECK_FORM_UPDATED: {
        TITLE: '{0} check form is updated'
    },
    SAVED_CHANGES_RESULT_DIALOG: {
        TITLE: 'Changes Saved!'
    },
    PRICE_CREATED_RESULT_DIALOG: {
        TITLE: 'Price Created.'
    },
    PRICE_UPDATED_RESULT_DIALOG: {
        TITLE: 'Price Updated.'
    },
    PRICE_DELETED_RESULT_DIALOG: {
        TITLE: 'Price Deleted.'
    },
    BULK_RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: 'Candidates to Client links created!'
    },
    RELATIONSHIP_CREATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link created!'
    },
    RELATIONSHIP_UPDATED_RESULT_DIALOG: {
        TITLE: 'Candidate to Client link updated!'
    },
    OFFER_UPDATED_RESULT_DIALOG: {
        TITLE: 'Offer Updated!'
    },
    REVIEW_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for leaving a review!'
    },
    MARKED_FAVORITE_RESULT_DIALOG: {
        TITLE: 'Marked as favorite!',
        MESSAGE: 'We will do our best to match you with them in the future.'
    },
    MARKED_DONT_WANT_RESULT_DIALOG: {
        TITLE: 'Thank you for letting us know.',
        MESSAGE: 'We will do our best to connect you with others in the future'
    },
    PAYMENT_SUBMITTED_RESULT_DIALOG: {
        TITLE: 'Thank you for submitting your payment information!'
    },
    PACKAGE_SELECTED_RESULT_DIALOG: {
        TITLE: 'Your package has been selected, thanks!',
        MESSAGE: "Our search is underway, we'll be in touch soon!"
    },
    EVALUATION_CREATED_RESULT_DIALOG: {
        TITLE: "Evaluation created."
    },
    EVALUATION_UPDATED_RESULT_DIALOG: {
        TITLE: "Evaluation updated."
    },
    EVALUATION_DELETED_RESULT_DIALOG: {
        TITLE: "Evaluation deleted."
    },
    QUESTION_CREATED_RESULT_DIALOG: {
        TITLE: "Question created."
    },
    BLOCKTEXT_CREATED_RESULT_DIALOG: {
        TITLE: "Block of text created"
    },
    QUESTION_UPDATED_RESULT_DIALOG: {
        TITLE: "Question updated."
    },
    BLOCKTEXT_UPDATED_RESULT_DIALOG: {
        TITLE: "Block of text updated"
    },
    QUESTION_DELETED_RESULT_DIALOG: {
        TITLE: "Question deleted."
    },
    BLOCKTEXT_DELETED_RESULT_DIALOG: {
        TITLE: "Block of text deleted"
    },
    EVALUATION_ADDED_RESULT_DIALOG: {
        TITLE: "Evaluation added!"
    },
    EVALUATION_COMPLETED_RESULT_DIALOG: {
        TITLE: "{0} completed, thanks!",
        CLOSE_LABEL: "Done"
    },
    TIME_OFF_REQUEST_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Your time off request has been submitted, we'll review it and confirm when it's approved!",
        CLOSE_LABEL: "Done"
    },
    AVAILABILITY_NOTES_UPDATED_RESULT_DIALOG: {
        TITLE: "Notes updated!",
        CLOSE_LABEL: "Continue"
    },
    BUFFER_TIME_UPDATED_RESULT_DIALOG: {
        TITLE: "Buffer Time updated!",
    },
    MAX_BOOKING_NUMBER_UPDATED_RESULT_DIALOG: {
        TITLE: "Maximum number of booking per day updated!",
    },
    SCHEDULE_UPDATED_RESULT_DIALOG: {
        TITLE: "Schedule updated."
    },
    DOCUMENT_SEND_TO_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Document is sent to candidate"
    },
    DOCUMENT_MARK_AS_DRAFT_RESULT_DIALOG: {
        TITLE: "Document is marked as draft"
    },
    DOCUMENT_PUBLISH_RESULT_DIALOG: {
        TITLE: "Document is published"
    },
    DOCUMENT_UPDATED_RESULT_DIALOG: {
        TITLE: "Document is updated"
    },
    BOOKING_ON_BLOCKED_DATES_RESULT_DIALOG: {
        TITLE: "Our apologies, we are booked up for this date! We will add you to our cancelation list and inform you of any changes ASAP.",
        CLOSE_LABEL: "Continue"
    },
    CHECKLIST_SAVED_RESULT_DIALOG: {
        TITLE: "Checklist is saved"
    },
    FEEDBACK_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Thanks, we will be in touch shortly."
    },
    FEEDBACK_SUBMITTED_SUCCESS_RESULT_DIALOG: {
        TITLE: "Thanks for submitting the feedback"
    },
    USER_ALERT_BLOCKED_POPUP_DIALOG: {
        TITLE: "If a new window has not opened please check if pop-ups were blocked",
        CLOSE_LABEL: "Cancel"
    },
    CLOCK_OUT_SUCCESS_RESULT_DIALOG: {
        TITLE: "Thanks!",
        MESSAGE: "If there were any issues with recording the time, or anything else, please let us know.",
        CLOSE_LABEL: "Done"
    },
    CLOCK_OUT_TRANSFER_SUCCESS_RESULT_DIALOG: {
        TITLE: "Thanks!",
        MESSAGE: "You will be paid directly through Stripe. If there were any issues with recording the times or anything else, please let us know.",
        CLOSE_LABEL: "Done"
    },
    CLOCK_IN_SUCCESS_RESULT_DIALOG: {
        TITLE: "Thanks!",
        MESSAGE: "Don't forget to clock out when you are finished!",
        CLOSE_LABEL: "Done"
    },
    SCHEDULE_RELEASED_RESULT_DIALOG: {
        TITLE: "The schedule has been released!"
    },
    EVENT_BOOKED_RESULT_DIALOG: {
        TITLE: "Event booked!"
    },
    DOCUMENT_ADDED_RESULT_DIALOG: {
        TITLE: "Document added!"
    },
    MAILCHIMP_ADDED_RESULT_DIALOG: {
        TITLE: "Successfully subscribed to Mailchimp List!"
    },
    TENTATIVE_ASSIGN_RESULT_DIALOG: {
        TITLE: "Nanny tentatively assigned.",
    },
    TENTATIVE_ASSIGN_HAS_BIG_RED_BTN_RESULT_DIALOG: {
        TITLE: "Nanny tentatively assigned.",
        MESSAGE: "Nobody has been notified, they will be when you push the big red button"
    },
    SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} information submitted",
        MESSAGE: "Thank you for submitting {0} information. Please close the window or submit another {1}"
    },
    USER_SECTION_PUBLIC_FORM_SUBMITTED: {
        TITLE: "{0} information submitted",
        MESSAGE: "Thank you for submitting {0} information. Please close the window"
    },
    CANDIDATE_SELECTED_RESULT_DIALOG: {
        TITLE: "Thank you for selecting candidate"
    },
    CLOCK_IN_OUT_APPROVED_RESULT_DIALOG: {
        TITLE: "Clock in and clock out times are approved"
    },
    CLOCK_IN_OUT_DISAPPROVED_RESULT_DIALOG: {
        TITLE: "Clock in and clock out times are disapproved"
    },
    PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: '{0} Credits added, thanks!',
    },
    MONTHLY_PACKAGE_CREDIT_SELECTED_RESULT_DIALOG: {
        TITLE: '{0} Monthly Credits added, thanks!',
    },
    STRIPE_SUBSCRIPTION_SELECTED_RESULT_DIALOG: {
        TITLE: "Subscription started, thank you!"
    },
    UNASSIGN_CANDIDATE_RESULT_DIALOG: {
        TITLE: "Candidate unassigned"
    },
    SAVED_ADVANCE_SEARCH_RESULT_DIALOG: {
        TITLE: "Saved advance search"
    },
    BOOKING_ADDED_RESULT_DIALOG: {
        TITLE: "Booking added"
    },
    JOB_TIP_ADDED_RESULT_DIALOG: {
        TITLE: "Tip added"
    },
    BULK_COPY_SUGGESTED_CHARGE_RESULT_DIALOG: {
        TITLE: "Copied Suggested Charge to Total Client Charge"
    },
    CANDIDATES_NO_LONGER_AVAILABLES: {
        TITLE: 'The selected candidate is no longer available',
        MESSAGE: 'The selected candidate ({0}) is no longer available. Please select another candidate',
        CLOSE_LABEL: 'OK'
    },
    RESELECT_JOB_FILLER_RESULT_DIALOG: {
        TITLE: "Booking date/time is changed. Please reselect candidate for the booking",
        CLOSE_LABEL: "OK"
    },
    REQUEST_TIMEOFF_APPROVED_RESULT_DIALOG: {
        TITLE: "Request approved"
    },
    REQUEST_TIMEOFF_DECLINED_RESULT_DIALOG: {
        TITLE: "Request declined"
    },
    MARK_SELECTED_TASK_COMPETED_RESULT_DIALOG: {
        TITLE: "Marked selected tasks as complete"
    },
    SCRAPER_STATUS_RESULT_DIALOG: {
        TITLE: "This may take a few minutes, please continue what you are doing and refresh in a few minutes."
    },
    SHIFT_JOB_REPORT_SUBMITTED: {
        TITLE: "{0} report submitted successfully"
    },
    MANUAL_TRANSFER_SUCCESS: {
        TITLE: "Transfer successfully",
        MESSAGE: "Transfer ID: {0}"
    },
    EMAIL_SENT_RESULT_DIALOG: {
        TITLE: "Emails sent"
    },
    MARK_JOB_COMPLETED_RESULT_DIALOG: {
        TITLE: "Marked job as completed"
    },
    PACKAGE_CREATED_RESULT_DIALOG: {
        TITLE: "Package created."
    },
    PACKAGE_UPDATED_RESULT_DIALOG: {
        TITLE: "Package updated."
    },
    PACKAGE_DELETED_RESULT_DIALOG: {
        TITLE: "Package deleted."
    },
    TIP_CHARGE_RESULT_DIALOG: {
        TITLE: "Your tip has been sent to {0}, thank you so much!"
    },
    REPORT_PROBLEM_RESULT_DIALOG: {
        TITLE: "Problem is reported successfully"
    },
    COPY_USER_FIELD_RESULT_DIALOG: {
        TITLE: "Fields are copied successfully",
        MESSAGE: "Data is copied from {0} to {1}"
    },
    CANCEL_EMAIL_RESULT_DIALOG: {
        TITLE: "Email is cancelled"
    },
    REVIEW_DELETED_RESULT_DIALOG: {
        TITLE: "Review deleted."
    },
    NEED_AGENCY_PHONE_RESULT_DIALOG: {
        TITLE: "You don't have SMS set up yet!",
        MESSAGE: "Please contact our team to get started."
    },
    ADDITIONAL_DATE_ADDED_RESULT_DIALOG: {
        TITLE: "Booking(s) added"
    },
    INVOICE_SENT_RESULT_DIALOG: {
        TITLE: "Invoice sent"
    },
    STRIPE_ACCOUNT_DELETED: {
        TITLE: "Stripe account deleted"
    },
    SUBMITTED_MODAL_RESULT_DIALOG: {
        TITLE: "Thanks, we will be in touch shortly!"
    },
    NO_CANDIDATE_AVAILABLE_FOR_ALL_BOOKING: {
        TITLE: "There is no candidate who is available for all open bookings"
    },
    RETURNING_APPLICANT_RESULT_DIALOG: {
        TITLE: "Your previously entered information has been loaded, please continue!"
    },
    JOB_SHARE_MARKET_PLACE_RESULT_DIALOG: {
        TITLE: "Job is shared with the agency marketplace"
    },
    CANDIDATE_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Candidate is submitted to the job"
    },
    BULK_RESOURCE_DELETED_RESULT_DIALOG: {
        TITLE: "{0} {1} deleted"
    },
    REPEAT_BLASTER_BEING_SENT_RESULT_DIALOG: {
        TITLE: "{0}s are being sent"
    },
    BOOKING_SUBMITTED_RESULT_DIALOG: {
        TITLE: "Your booking are submitted, you can close the window"
    },
    FILLED_JOB_RESULT_DIALOG: {
        TITLE: "This job has been filled!"
    }
}


// WEBPACK FOOTER //
// ./src/constants/multi-languages/result-dialog/en.js